<template>
  <div class="modal" :class="{ fadeIn: visible, fadeOut: !visible }" v-if="visible && compyinfo">
    <div class="modal-mask-cf"/>
    <div class="modal-con">
      <div class="modal-con-main">
        <span class="iconfont icon-guanbi" @click="handleClose"/>
        <div class="m-header">确认下载简历</div>
        <div class="m-text-1">加入人才库后可显示联系方式，随时查看人才信息</div>
        <div class="m-content">
          <div class="content-box">
            <div class="confirm-text">确认下载<span class="name">{{ name }}</span>的简历，并加入企业人才库吗？</div>
            <div class="cost-text" v-if="compyinfo.isVip || compyinfo.remainCollNum > 0">
              需要消耗下载权益<font class="blue">1</font>次，
              <span class="s">剩余免费下载次数：<font :class="compyinfo.remainCollNum ? 'blue' : 'red'">{{ compyinfo.remainCollNum }}</font>次</span>
            </div>
            <div class="cost-text" v-else>
              需要消耗<font class="red">10.0</font>平台币，<span class="s">当前的账户余额：<font class="red">{{ compyinfo.availableFunds }}</font>平台币</span>
            </div>
          </div>
          <div class="content-box position-select" v-if="!recruitId">
            <span class="required">*</span>简历关联的岗位
            <el-select v-model="selectedPosition" placeholder="请选择岗位">
              <el-option v-for="item in positions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </div>
          <template v-if="compyinfo.isVip || compyinfo.remainCollNum > 0">
            <el-button :disabled="!compyinfo.remainCollNum" class="submit-btn" type="primary" @click="handleDownload">
              确认下载
            </el-button>
            <div v-if="!compyinfo.remainCollNum" class="vip-text" @click="gocharge">去充值</div>
          </template>
          <template v-else>
            <el-button v-if="!showpwd" class="submit-btn" type="primary" @click="pingchange">支付10.0平台币</el-button>
            <div v-else style="position: relative; width: 100%; height: 46px; margin-top: 10px;">
              <ul class="mz-pwd">
                <li v-for="(item, i) in pwdlist" :key="i">{{ item }}</li>
              </ul>
              <input @focus="focusInput"
                     v-model="pwdIinps"
                     maxlength="6"
                     placeholder="请输入密码"
                     :type="inputType"
                     class="mz-btn mz-btn-orange mz-inp-orange"
                     autocomplete="off"/>
            </div>
            <div class="vip-text" @click="goVip">开通会员获得免费次数</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NewConfirm',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        default: 'xx'
      },
      workerId: {
        type: [Number, String],
        default: ''
      },
      recruitId: {
        type: [Number, String],
        default: ''
      },
      type: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selectedPosition: '',
        positions: [],
        compyinfo: null,
        showpwd: false,
        pwdlist: ['', '', '', '', '', ''],
        pwdIinps: '',
        options: {
          text: '加载中，请稍后',
          target: '#conformbox'
        },
        inputType: 'text',
      }
    },
    beforeRouteLeave(to, from, next) {
      this.inputType = 'text';
      next();
    },
    watch: {
      pwdIinps(newval) {
        this.pwdlist[0] = newval[0] ? '*' : '';
        this.pwdlist[1] = newval[1] ? '*' : '';
        this.pwdlist[2] = newval[2] ? '*' : '';
        this.pwdlist[3] = newval[3] ? '*' : '';
        this.pwdlist[4] = newval[4] ? '*' : '';
        this.pwdlist[5] = newval[5] ? '*' : '';
        if (newval.length === 6) {
          this.buyinfo();
        }
      }
    },
    methods: {
      handleClose() {
        this.$emit('update:visible', false);
      },
      pingchange() {
        if (!this.selectedPosition && !this.recruitId) {
          this.$message.warning('请选择关联岗位');
          return;
        }
        this.showpwd = true;
      },
      focusInput() {
        this.inputType = 'password';
      },
      buyinfo() {
        this.loadingObj = this.$loading(this.options);
        const recruitId = this.selectedPosition || this.recruitId;
        this.axios.get(`/wapi/hr/buyResume?workerId=${this.workerId}&recruitId=${recruitId}&password=${this.pwdIinps}`).then(res => {
          setTimeout(() => {
            this.loadingObj.close();
          }, 300);
          if (res.success) {
            this.$message('下载成功，请到【待约面】列表查看');
            if (this.type) {
              this.handleClose();
              this.$emit('getList');
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 400);
            }
          } else {
            this.pwdIinps = "";
          }
        });
      },
      gocharge() {
        this.$router.replace({ path: '/index/finance/recharge' });
      },
      goVip() {
        this.$router.replace({ path: '/index/member/info' });
      },
      handleDownload() {
        if (!this.selectedPosition && !this.recruitId) {
          this.$message.warning('请选择关联岗位');
          return;
        }
        const recruitId = this.selectedPosition || this.recruitId;
        const workerId = this.workerId;
        const url = `/wapi/hr/collWorker?workerId=${workerId}&recruitId=${recruitId}`;
        this.axios.get(url).then(res => {
          if (res.success) {
            this.$message('下载成功，您可以在“简历管理”页查看');
            if (this.type) {
              this.handleClose();
              this.$emit('getList');
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 400);
            }
          } else {
            this.pwdIinps = "";
          }
        });
      },
      getInfo() {
        let url = "/wapi/company/detail";
        this.axios.get(url).then(res => {
          this.compyinfo = res.data;
        });
      },
      getOptions() {
        let url = '/wapi/hr/recruit/pageRecruiting?pageNum=1&pageSize=20';
        this.axios.get(url).then(res => {
          this.positions = res.rows.map(f => ({
            label: f.title,
            value: f.id
          }));
        });
      }
    },
    created() {
      this.getInfo();
      this.getOptions();
    }
  };
</script>

<style lang="less" scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;

    &.fadeIn {
      animation: fadeIn .3s ease-in-out;
    }

    &.fadeOut {
      animation: fadeOut .3s ease-in-out;
    }

    .modal-mask-cf {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }

    .modal-con {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 532px;
      background: linear-gradient(180deg, #D4EEFF 0%, rgba(242, 246, 249, 0.1) 100%), #FFFFFF;
      border-radius: 12px;

      .modal-con-main {
        position: relative;
        padding: 30px 36px 22px;

        .icon-guanbi {
          position: absolute;
          top: 24px;
          right: 36px;
          cursor: pointer;
          font-size: 14px;
          color: #333333;

          &:hover {
            color: #666;
          }
        }

        .m-header {
          font-weight: 500;
          font-size: 22px;
          color: #2B2B2B;
          line-height: 20px;
          margin-bottom: 12px;
        }

        .m-text-1 {
          font-size: 14px;
          color: rgba(4, 15, 36, 0.65);
          line-height: 16px;
          margin-bottom: 24px;
        }

        .m-content {
          color: rgba(51, 51, 51, 1);

          .confirm-text {
            font-size: 18px;
            line-height: 18px;
            margin-bottom: 16px;

            .name {
              color: #409EFF;
            }
          }

          .cost-text {
            font-size: 16px;

            .s {
              font-size: 14px;
              color: rgba(142, 147, 156, 1);
            }

            .red {
              color: #F56C6C;
            }

            .blue {
              color: rgba(5, 125, 249, 1);
            }
          }

          .content-box {
            background-color: #ffffff;
            border-radius: 4px;
            padding: 20px 16px;

          }

          .position-select {
            margin-top: 10px;
            margin-bottom: 20px;
            font-size: 14px;

            .required {
              color: #F56C6C;
              margin-right: 4px;
            }

            .el-select {
              width: 100%;
              margin-top: 8px;
            }
          }

          .submit-btn {
            width: 100%;
            margin-bottom: 16px;
            background: linear-gradient(90deg, #057CF9 0%, #1AAFFD 100%) !important;
            border: none !important;
          }

          .m-groups {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-bottom: 15px;

            .m-cancel-button,
            .m-confirm-button {
              padding: 9px 20px;
              border-radius: 4px;
              cursor: pointer;
              font-size: 14px;
              text-align: center;
            }

            .m-cancel-button {
              border: 1px solid #DCDFE6;
              color: #606266;

              &:hover {
                color: #409EFF;
                border-color: #c6e2ff;
                background-color: #ecf5ff;
              }
            }

            .m-confirm-button {
              background-color: #409EFF;
              color: #fff;

              &:hover {
                background-color: #66b1ff;
              }
            }
          }

          .vip-text {
            text-align: center;
            color: #409EFF;
            font-size: 12px;
            cursor: pointer;

            &:hover {
              color: #66b1ff;
            }
          }

          .mz-pwd {
            width: 100%;
            overflow: hidden;
            padding-left: 1px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
          }

          .mz-pwd li {
            float: left;
            width: 53px;
            height: 42px;
            border: 1px solid #ccc;
            margin-left: -1px;
            text-align: center;
            line-height: 42px;
            border-radius: 1px;
          }

          .mz-btn {
            height: 44px;
            border-radius: 4px;
            text-align: center;
            line-height: 44px;
            font-size: 14px;
            cursor: pointer;
          }

          .mz-btn {
            height: 44px;
            border-radius: 4px;
            text-align: center;
            line-height: 44px;
            font-size: 14px;
            cursor: pointer;
          }

          .mz-btn-orange {
            color: #ff971c;
            border: 1px solid #ff971c;
          }

          .mz-inp-orange {
            text-align: left;
            text-indent: 10px;
            border: none;
            cursor: text;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
            z-index: 10;
          }
        }
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// NewConfirm.vue?a9e7df40